export const en = {
  "nav.platform": "Platform",
  "nav.services": "Services",
  "nav.useCases": "Use Cases",
  "nav.resources": "Resources",
  "nav.pricing": "Pricing",
  "nav.insights": "Insights",
  "nav.login": "Login",
  "nav.mediaMonitoring": "Media Monitoring",
  "nav.mediaAnalysis": "Media Analysis",
  "nav.whoWeHelp": "Who We Help",
  "nav.industries": "Industries",
  "nav.company": "Company",
  "cta.requestDemo": "Request a demo",
  "footer.col.platform": "Platform",
  "footer.col.services": "Services",
  "footer.col.resources": "Resources",
  "footer.col.company": "Company",
  "footer.tagline": "Media intelligence built for the teams that shape the narrative across Europe.",
  "footer.hq.value": "Sofia, Bulgaria",
  "footer.copyright": "© Perceptica. All Rights Reserved. 2012-2026.",
  "footer.link.requestDemo": "Request a demo",
  "footer.link.mlp": "Media Listening Platform",
  "footer.link.coverage": "Coverage",
  "footer.link.pricing": "Pricing",
  "footer.link.faq": "FAQ",
  "footer.link.mediaAnalysis": "Media Analysis",
  "footer.link.reputation": "Reputation Analysis",
  "footer.link.competitive": "Competitive Intelligence",
  "footer.link.crisis": "Crisis Monitoring",
  "footer.link.market": "Market Research",
  "footer.link.employer": "Employer Branding Analysis",
  "footer.link.blog": "Blog",
  "footer.link.reports": "Reports",
  "footer.link.whoWeHelp": "Who We Help",
  "footer.link.whyPerceptica": "Why Perceptica",
  "footer.link.about": "About us",
  "footer.link.careers": "Careers",
  "footer.link.contact": "Contact",
  "footer.link.partners": "Partners & Press",
  "footer.link.privacy": "Privacy Policy",
  "footer.link.cookies": "Cookie Policy",
  "locale.switchTo.bg": "БГ",
  "locale.switchTo.en": "EN",
  "cookie.title": "Your privacy",
  "cookie.bodyBefore": "We use essential cookies to make this site work. With your consent we may also use analytics and marketing cookies to understand how the site is used and improve your experience. See our ",
  "cookie.bodyLink": "cookie policy",
  "cookie.bodyAfter": ".",
  "cookie.acceptAll": "Accept all",
  "cookie.rejectNonEssential": "Reject non-essential",
  "cookie.manage": "Manage",
  "cookie.savePreferences": "Save preferences",
  "cookie.close": "Close",
  "cookie.cat.necessary": "Strictly necessary",
  "cookie.cat.necessaryDesc": "Required for the site to work. Always on.",
  "cookie.cat.analytics": "Analytics",
  "cookie.cat.analyticsDesc": "Google Analytics - helps us understand how the site is used.",
  "cookie.cat.marketing": "Marketing",
  "cookie.cat.marketingDesc": "HubSpot and LinkedIn - measure campaigns and show relevant content.",
  "footer.cookieSettings": "Cookie Settings",
} as const;

export type MessageKey = keyof typeof en;